import React, { useEffect, useState, useRef, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Modal, Form, Table, Image } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import LinearProgress from "@mui/material/LinearProgress";

import AddSubCategory from "./AddSubCategory";
import EditSubCategory from "./EditSubCategory";

const SubCategoryManagementPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [subcategories, setsubCategories] = useState([]);

  const [subcategory, setsubCategory] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleCloseAddModal = () => {
    setShowAddModal(false);
  };
  const handleCloseEditModal = () => {
    setsubCategory(null);
    setShowEditModal(false);
  };

  useEffect(() => {
    fetchAllSubCategory();
  }, []);

  const fetchAllSubCategory = async () => {
    setLoading(true);

    const response = await axios.post(BASE_URL + "API/apicall", {
      security_key: security_key,
      mode: "getAllSubCategory",
    });

    const output = response.data;

    if (output.length > 0) {
      setsubCategories(output);
    }
    setLoading(false);
  };

  const handleEdit = async (row) => {
    setsubCategory(row);
    setShowEditModal(true);
  };

  const handleDelete = async (sub_cat_key) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it",
      });

      if (result.isConfirmed) {
        const response = await axios.post(BASE_URL + "API/apicall", {
          security_key: security_key,
          mode: "deleteSubCategory",
          pk_sub_cat_key: sub_cat_key,
        });

        const output = response.data;

        if (output) {
          await Swal.fire(
            "Deleted!",
            "The sub category has been successfully removed.",
            "success"
          );
          fetchAllSubCategory();
        }
      }
    } catch (error) {
      // Handle any errors here
      console.error("An error occurred: ", error);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;
  const totalPages = Math.ceil(subcategories.length / ITEMS_PER_PAGE);

  const paginatedCategory = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    const end = start + ITEMS_PER_PAGE;
    return subcategories.slice(start, end);
  }, [subcategories, currentPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
};


  return (
    <div className="container my-4">
      <ToastContainer position="top-center" />
      <div className="d-flex justify-content-between align-items-center admin-page-head">
        <h4 className="mb-0">Sub Category Management</h4>
        <div className="mt-2 d-flex flex-wrap gap-2">
          <Button variant="dark" onClick={() => setShowAddModal(true)}>
            Add Sub Category
          </Button>
        </div>
      </div>

      <div className="table-responsive mt-3">
        <Table striped bordered hover className="table-responsive-scroll">
          <thead className="thead-dark">
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Category</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={4} className="p-0">
                  <LinearProgress />
                </td>
              </tr>
            )}
            {!loading &&  paginatedCategory.length === 0 && (
              <tr>
                <td colSpan={4}>
                  <h6 className="text-center">Data not available</h6>
                </td>
              </tr>
            )}
            {paginatedCategory.map((row) => (
              <tr key={row.pk_sub_cat_key}>
                <td>{row.subcat_name}</td>
                <td>{row.subcat_description}</td>
                <td>{row.cat_name}
                </td>
                <td className="">
                  <div className="h-100 d-flex flex-wrap flex-md-nowrap gap-2 gap-md-1">
                    <Button
                      variant="outline-dark"
                      className="btn-sm me-2"
                      onClick={() => handleEdit(row)}
                      data-bs-toggle="tooltip"
                      title="Edit"
                    >
                      <i className="fa-solid fa-pen-to-square"></i>
                    </Button>
                    <Button
                      variant="outline-danger"
                      className="btn-sm"
                      onClick={() => handleDelete(row.pk_sub_cat_key)}
                      data-bs-toggle="tooltip"
                      title="Delete"
                    >
                      <i className="fa-solid fa-trash"></i>
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="pagination d-flex justify-content-end my-3">
          <Button
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
            className="btn btn-light mx-1"
          >
            &lt;&lt;
          </Button>
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="btn btn-light mx-1"
          >
            &lt;
          </Button>
          {Array.from({ length: totalPages }, (_, index) => (
            <Button
              key={index + 1}
              onClick={() => handlePageChange(index + 1)}
              className={`mx-1 ${
                currentPage === index + 1 ? "btn-dark text-white" : "btn-light"
              }`}
            >
              {index + 1}
            </Button>
          ))}
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="btn btn-light mx-1"
          >
            &gt;
          </Button>
          <Button
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            className="btn btn-light mx-1"
          >
            &gt;&gt;
          </Button>
        </div>
      </div>
      <AddSubCategory
        showModal={showAddModal}
        handleClose={handleCloseAddModal}
        fetchAllSubCategory={fetchAllSubCategory}
      />
      <EditSubCategory
        showModal={showEditModal}
        handleClose={handleCloseEditModal}
        fetchAllSubCategory={fetchAllSubCategory}
        subcategory={subcategory}
      />
    </div>
  );
};

export default SubCategoryManagementPage;
